import { useRef } from 'react';
import type { DragContext } from '@model-framework/ui';
import { DraggableSVGGElement } from '@model-framework/ui';
import { useD3DblClickCallback } from '@view-model/models/common/hooks';
import type { Position } from '@view-model/models/common/types/ui';

type Props = {
  position: Position;
  onDblClick(): void;
  onDragStart(): void;
  onDrag(context: DragContext): void;
  onDragEnd(): void;
};

export const BendingPoint: React.FC<Props> = ({ position, onDblClick, onDrag, onDragEnd, onDragStart }: Props) => {
  const domRef = useRef<SVGGElement>(null);

  const handleDragStart = () => {
    onDragStart();
  };

  const handleDrag = (context: DragContext) => {
    onDrag(context);
  };

  const handleDragEnd = () => {
    onDragEnd();
  };

  useD3DblClickCallback(
    domRef,
    function () {
      onDblClick();
    },
    true
  );

  return (
    <g ref={domRef}>
      <DraggableSVGGElement
        position={position}
        onDragStart={handleDragStart}
        onDrag={handleDrag}
        onDragEnd={handleDragEnd}
      >
        <circle r="16" fill="white" stroke="#aaa" strokeWidth="4" className="hover:fill-brand" />
      </DraggableSVGGElement>
    </g>
  );
};
